export default __webpack_public_path__ + "static/media/Brief.c790b37f.svg";